export default "__VITE_ASSET__80b846c4__"